import JSZip from 'jszip'
import { Booklet } from '../../../../../types/generated.types'
import { sanitizeFileSystemName } from '../../../utils/bookletFolderUtils'

const { REACT_APP_IMAGE_BASE_URL } = process.env

interface GenerateMobileImagesParams {
  associationBooklets: Booklet[]
}

/**
 * Downloads mobile images for booklets (booklet and single booklet images)
 */
export const generateMobileImages = async ({
  associationBooklets
}: GenerateMobileImagesParams): Promise<JSZip> => {
  const zip = new JSZip()

  const downloadImageFromUrl = async (imageUrl: string): Promise<Blob> => {
    try {
      const response = await fetch(imageUrl)
      if (!response.ok) {
        throw new Error(`Failed to fetch image: ${response.statusText}`)
      }
      return await response.blob()
    } catch (error) {
      console.error('Error downloading image:', error)
      throw error
    }
  }

  const downloadPromises = associationBooklets.map(async (booklet) => {
    // Download imageOfBookletInAppURL if it exists
    if (booklet.imageOfBookletInAppURL) {
      try {
        const imageUrl = `${REACT_APP_IMAGE_BASE_URL}${booklet.imageOfBookletInAppURL}`
        const blob = await downloadImageFromUrl(imageUrl)
        const fileName = `${sanitizeFileSystemName(booklet.title)}-booklet.png`
        zip.file(fileName, blob)
      } catch (error) {
        console.error(`Error downloading booklet image for ${booklet.title}:`, error)
      }
    }

    // Download imageOfSingleBookletInAppURL if it exists
    if (booklet.imageOfSingleBookletInAppURL) {
      try {
        const imageUrl = `${REACT_APP_IMAGE_BASE_URL}${booklet.imageOfSingleBookletInAppURL}`
        const blob = await downloadImageFromUrl(imageUrl)
        const fileName = `${sanitizeFileSystemName(booklet.title)}-single-booklet.png`
        zip.file(fileName, blob)
      } catch (error) {
        console.error(`Error downloading single booklet image for ${booklet.title}:`, error)
      }
    }
  })

  await Promise.all(downloadPromises)
  return zip
}

